import { useEffect, useState } from 'react';

export const useCheckbox = (onChange?: (ids: number[]) => void) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  useEffect(() => {
    if (onChange) onChange(selectedIds);
  }, [onChange, selectedIds]);

  const onCheckboxChange = (id: number) => (isSelected: boolean) => {
    setSelectedIds(isSelected ? [...selectedIds, id] : selectedIds.filter((x) => x !== id));
  };

  const isChecked = (id: number) => selectedIds.includes(id);

  return {
    onCheckboxChange,
    isChecked,
    selectedIds,
  };
};
